import Tooltip from '@mui/material/Tooltip';
import { withStyles } from '@mui/styles';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const styles = theme => ({
    root: {
        display: 'inline-block',
        marginBottom: theme.spacing(1.5),
    },
    label: {
        display: 'block',
        margin: '-3px 0',
    },
    question: {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginLeft: theme.spacing(),
        cursor: 'pointer',
    },
    tooltip: {
        backgroundColor: theme.palette.common.white,
        border: '1px solid #bbb',
        color: 'rgba(0,0,0,.987)',
        fontSize: 12,
        fontWeight: 400,
        display: 'block',
        letterSpacing: 'normal',
        lineHeight: '16px',
        padding: [9, 12, 7],
        position: 'relative',
        textTransform: 'none',
    },
    iconWrapper: {
        display: 'inline-block',
        fontSize: 0,
        position: 'relative',
    },
    iconHelpWrapper: {
        height: 8,
        width: 12,
        marginLeft: 4,
        '& svg': {
            height: 12,
            width: 12,
            position: 'absolute',
            left: 0,
            top: -2,
        },
    },
});

const QuestionMark = () => (
    <svg viewBox="0 0 12 12">
        {' '}
        <path
            fill="#CCCCCC"
            d="M6,0 C2.686,0 0,2.686 0,6 C0,9.314 2.686,12 6,12      C9.314,12 12,9.314 12,6 C12,2.686 9.313,0 6,0 L6,0 Z      M5.99663896,10.7141315      C5.70758933,10.7141315 5.48576055,10.6334665          5.33003226,10.4710161      C5.17430397,10.3085658 5.097,10.1080236 5.097,9.86714888      C5.097,9.74503102 5.11716625,9.63075558 5.15637841,9.52544293      C5.19559057,9.42013027 5.25384864,9.32826179          5.33003226,9.24983747      C5.40621588,9.17141315 5.50032506,9.10979404          5.6123598,9.0661005      C5.72439454,9.02240695 5.85211414,9 5.99663896,9      C6.14116377,9 6.26888337,9.02240695 6.38091811,9.0661005      C6.49295285,9.10979404 6.58706203,9.17141315          6.66324566,9.24983747      C6.73942928,9.32826179 6.79880769,9.42013027          6.84026055,9.52544293      C6.8817134,9.63075558 6.903,9.74391067 6.903,9.86714888      C6.903,10.1080236 6.82457568,10.3096861 6.6666067,10.4710161      C6.50863772,10.6334665 6.28568859,10.7141315          5.99663896,10.7141315 Z      M8.0685,5.631      C7.9315,5.826 7.7755,6.013 7.5995,6.193      C7.4235,6.373 7.2425,6.55 7.0545,6.726      C6.8395,6.922 6.6965,7.065 6.6245,7.297      C6.5525,7.529 6.5145,8.015 6.5105,8.015 L5.1805,8.015      C5.1805,8.015 5.1975,7.567 5.2305,7.362      C5.2635,7.157 5.3175,7.005 5.3935,6.835      C5.4695,6.665 5.5685,6.522 5.6895,6.369      C5.8105,6.216 5.9595,6.063 6.1345,5.891      C6.2675,5.762 6.3915,5.644 6.5065,5.529      C6.6215,5.414 6.7235,5.298 6.8115,5.177      C6.8995,5.056 6.9685,4.928 7.0195,4.791      C7.0705,4.654 7.0955,4.502 7.0955,4.335      C7.0955,3.968 7.0045,3.688 6.8235,3.494      C6.6425,3.3 6.3755,3.205 6.0235,3.205      C5.8825,3.205 5.2305,3.16700006 5.0005,3.657      C4.9355,3.79 4.9045,4.015 4.9045,4.015      L3.4805,4.015      C3.4845,4.015 3.5515,3.447 3.6825,3.167      C3.8135,2.887 3.9935,2.715 4.2215,2.526      C4.4495,2.337 4.7175,2.224 5.0245,2.129      C5.3315,2.034 5.6645,2 6.0235,2      C6.4185,2 6.7695,2.058 7.0785,2.16      C7.3875,2.262 7.6485,2.414 7.8635,2.609      C8.0785,2.804 8.2415,3.045 8.3525,3.326      C8.4635,3.607 8.5195,3.927 8.5195,4.282      C8.5195,4.54 8.4785,4.781 8.3965,5.004      C8.3145,5.227 8.2055,5.436 8.0685,5.631 Z"
        />{' '}
    </svg>
);

const Label = ({ value, helpText, classes }) => (
    <div className={classes.root}>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label className={classes.label}>
            <span>
                {value}
                {helpText && (
                    <Tooltip
                        title={helpText}
                        placement="top"
                        classes={{
                            tooltip: classes.tooltip,
                        }}
                    >
                        <span className={classnames(classes.iconWrapper, classes.iconHelpWrapper)}>
                            <QuestionMark className={classes.question} viewBox="0 0 12 12" />
                        </span>
                    </Tooltip>
                )}
            </span>
        </label>
    </div>
);

Label.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    helpText: PropTypes.node,
};

Label.defaultProps = {
    helpText: undefined,
};

const Wrapped = withStyles(styles, { withTheme: true })(Label);

export { Wrapped as Label, QuestionMark };
